import { useState } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

export function LaunchBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="relative bg-secondary text-secondary-foreground py-2.5 px-4 text-center text-sm font-medium">
      <div className="container flex items-center justify-center gap-2">
        <span>🎉 Launch Week! <span className="font-bold">Wrangling Chaos</span> is now available in eBook —</span>
        <a
          href="https://a.co/d/02CjmGgQ"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 font-semibold hover:text-brand-yellow transition-colors"
        >
          Get your copy
        </a>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-secondary-foreground/10 transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
